import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as RoutesDefinitions from 'apps/console/src/app/routes-definitions';
import { SubsidiariesStoreSelectors } from 'apps/console/src/app/root-store/subsidiaries-store';
import { AccessLevel } from 'apps/console/src/app/shared-module/enums';

import { ISubsidiaryListItem } from '../models';

@Injectable({
	providedIn: 'root'
})
export class SubsidiaryAdminGuard implements CanActivate {
	private store = inject(Store);
	private router = inject(Router);


	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
		const hasLoadedOnce$ = this.store.select(SubsidiariesStoreSelectors.selectHasLoadedOnce);
		const subsidiaryById$ = this.store.select(SubsidiariesStoreSelectors.selectSubsidiaryById(+route.params.id));

		return hasLoadedOnce$.pipe(
			filter(hasLoadedOnce => hasLoadedOnce),
			switchMap(_ => subsidiaryById$),
			map((subsidiary: ISubsidiaryListItem) => !!subsidiary && subsidiary.accessLevel === AccessLevel.Admin),
			map(canAccess => {
				if (!canAccess) { this.router.navigate([RoutesDefinitions.getSubsidiariesFullPath()]); }
				return canAccess;
			})
		);
	}
}
